module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-500.cb0ab582.woff";